
export enum FilingStatus {
  SINGLE = 'single',
  MARRIED_JOINT = 'marriedJoint',
  MARRIED_SEPARATE = 'marriedSeparate',
  HEAD_OF_HOUSEHOLD = 'headOfHousehold'
}
